
import dust from "dustjs-linkedin";


(function(){dust.register("lessons/lesson-creator/editor/notification",body_0);function body_0(chk,ctx){return chk.write("<span>").reference(ctx.get(["text"], false),ctx,"h").write("</span>").helper("svg",ctx,{},{"path":"account/tick"});}return body_0;})();

export default 0;
